import { CalendarAgendaIcon, GridIcon } from '@eventbrite/marmalade';
import { defineMessages, useIntl } from 'react-intl';

import styles from './EventsViewToggle.module.scss';

export type EventsDisplayMode = 'grid' | 'list';

const messages = defineMessages({
  groupAriaLabel: {
    id: 'Event list appearance',
    defaultMessage: 'Event list appearance',
  },
  gridAriaLabel: {
    id: 'Grid view',
    defaultMessage: 'Grid view',
  },
  listAriaLabel: {
    id: 'Chronological view',
    defaultMessage: 'Chronological view',
  },
});

interface Props {
  mode: EventsDisplayMode;
  onModeChange: (mode: EventsDisplayMode) => void;
}

export function EventsViewToggle({ mode, onModeChange }: Props) {
  const intl = useIntl();

  return (
    <div className={styles.root}>
      <div
        className={styles.toggleGroup}
        role="group"
        aria-label={intl.formatMessage(messages.groupAriaLabel)}
      >
        <button
          type="button"
          className={`${styles.toggleItem} ${mode === 'grid' ? styles.toggleItemActive : ''}`}
          aria-pressed={mode === 'grid'}
          aria-label={intl.formatMessage(messages.gridAriaLabel)}
          onClick={() => onModeChange('grid')}
        >
          <GridIcon size="small" aria-hidden />
        </button>
        <button
          type="button"
          className={`${styles.toggleItem} ${mode === 'list' ? styles.toggleItemActive : ''}`}
          aria-pressed={mode === 'list'}
          aria-label={intl.formatMessage(messages.listAriaLabel)}
          onClick={() => onModeChange('list')}
        >
          <CalendarAgendaIcon size="small" aria-hidden />
        </button>
      </div>
    </div>
  );
}
